module.exports = __webpack_public_path__ + "img/object-mark11.fd0f0dc4.png";